<template>
    <layout :showuserinfo="false" title="Tambah Hak Milik" :crumbs="crumbs">

    <center>

                <w-card class="xs6">
                    <center><h2>TARIK DATA iBAYAQ LAMA</h2></center><br>
                  <w-form @submit.prevent="submit">
                    <div align="left" >
                        <!-- <p ><span style="color:red">*</span> Pastikan No Hakmilik Tersebut Wujud Di SPTB</p>
                        <p ><span style="color:red">*</span> Masukkan Maklumat Seperti Yang Dari SPTB</p> -->
                    </div>
                    <br>
                    <div>
                        <w-flex>
                            <w-input
                                class="mb5"
                                outline
                                label="No Resit"
                                label-position="left"
                                type="text"
                                v-model="form.no_resit"
                                :validators="[validators.required]"
                                >
                            </w-input>

                        </w-flex>
                    </div>
                          <div class="d-flex justify-end mt3">
                            <w-button class="my1 mr0" type="submit" :loading="searching">
                              TARIK DATA
                            </w-button>
                          </div>

                  </w-form>
                </w-card>
                <!-- <w-card class="xs6">
                    <p align="left"><span style="color:red">*</span>Sila Semak Butiran Cukai Hakmilik Selepas Pindahan Berjay</p>
                    <p align="left"><span style="color:red">*</span>Sila Buat Semakan Cukai Tali Air Dengan Hakmilik Sebelum Jika Ada.</p>
                </w-card> -->



</center>
    </layout>
  </template>
  <script>
  import ZResource from "@/Modules/z-resource";
  import { Inertia } from "@inertiajs/inertia";
  import WaveUI from "wave-ui";
  import moment from "moment";
import Table from "../Component/Table.vue";
  export default {
    extends: ZResource,
    data() {
        return {
            waveui: new WaveUI(),
            masuk:false,
            validators: { required: (value) => !!value || "Sila Isi Ruangan Ini", },
            districts: [{ label: "Loading", selected: true }],
            mukim: [{ label: "Loading", selected: true }],
            jhm: [{ label: "Loading", selected: true }],
            kod_lot: [{ label: "Loading", selected: true }],
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            searching: false,
            form: {

                no_resit:null,
            },
            renderComponent: false,
            success: null,
            hakMilik:[],
            pemilikSPTB:[],
        };
    },
    methods: {
        async submit() {
            this.searching = true;
            await axios({
                method: "post",
                url:`${this.apiBaseUrl}/tarikIbayaq`,
                responseType: "json",
                data: this.form
            }).then((e) => {
                console.log(e.data);
                if (e.data.message == 'Success') {
                    this.$waveui.notify({
                        success: true,
                        message: "Berjaya! Maklumat rekod iBayaq telah dimasukkan.",
                        timeout: 3000,
                    });
                }
                else {
                    this.$waveui.notify({
                        error: true,
                        message: "Tiada Maklumat",
                        timeout: 3000,
                    });
                }
                // this.hakMilik.items=e.data.pemilikan;
                // console.log(this.hakMilik);
            }).finally((e) => {
                this.searching = false;
                // this.update();
            });
        },

    },
    created: function () {
        this.moment = moment;
    },

};
  </script>
